import { render } from "./BackPageButton.vue?vue&type=template&id=6b47c10e&scoped=true&ts=true"
import script from "./BackPageButton.vue?vue&type=script&lang=ts"
export * from "./BackPageButton.vue?vue&type=script&lang=ts"

import "./BackPageButton.vue?vue&type=style&index=0&id=6b47c10e&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b47c10e"]])

export default __exports__